'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UploadStatusBaseClass = require('./UploadStatusBaseClass');

var _UploadStatusBaseClass2 = _interopRequireDefault(_UploadStatusBaseClass);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _components = require('components');

var _uploads = require('helpers/uploads');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./FineUploader.scss');

var UploadStatusIcon = (_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(UploadStatusIcon, _Component);

  function UploadStatusIcon() {
    var _ref;

    (0, _classCallCheck3.default)(this, UploadStatusIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = UploadStatusIcon.__proto__ || (0, _getPrototypeOf2.default)(UploadStatusIcon)).call.apply(_ref, [this].concat(args)));

    _this.state = { processingStatus: false };
    return _this;
  }

  (0, _createClass3.default)(UploadStatusIcon, [{
    key: 'setProcessing',
    value: function setProcessing(val) {
      this.setState({ processingStatus: val });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      var _this2 = this;

      var _props = this.props,
          onCancel = _props.onCancel,
          onDelete = _props.onDelete,
          uploader = _props.uploader,
          id = _props.id;
      var _state = this.state,
          isComplete = _state.isComplete,
          isSuccess = _state.isSuccess;


      if (isSuccess) {
        if (onDelete) {
          this.setProcessing(true);

          onDelete().then(function () {
            uploader.methods.cancel(id);
            _this2.setProcessing(false);
          }).catch(function () {
            return _this2.setProcessing(false);
          });
        }
      } else if (!isComplete) {
        uploader.methods.cancel(id);
        if (onCancel) {
          onCancel();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          containerClassName = _props2.containerClassName,
          cancelable = _props2.cancelable,
          deletable = _props2.deletable;
      var _state2 = this.state,
          status = _state2.status,
          progress = _state2.progress,
          isSuccess = _state2.isSuccess,
          isComplete = _state2.isComplete,
          processingStatus = _state2.processingStatus;

      var isProcessing = progress === 100 && status === _uploads.STATUS.UPLOADING || processingStatus;
      var renderRes = null;

      if (isProcessing) {
        renderRes = _react2.default.createElement(_components.Loader, { size: 16 });
      } else if (isSuccess) {
        renderRes = deletable ? _react2.default.createElement('i', { className: (0, _bind2.default)('statusIcon', className, styles.statusIcon, 'icon-close colorError'), onClick: this.cancel }) : _react2.default.createElement('i', { className: (0, _bind2.default)('statusIcon', className, styles.statusIcon, 'icon-check colorSuccess') });
      } else if (!isComplete) {
        if (cancelable) {
          renderRes = _react2.default.createElement('i', { className: (0, _bind2.default)('statusIcon', className, styles.statusIcon, 'icon-close colorError'), onClick: this.cancel });
        }
      }

      return _react2.default.createElement(
        'span',
        { className: (0, _bind2.default)('statusIconContainer', styles.statusIconContainer, containerClassName) },
        renderRes
      );
    }
  }]);
  return UploadStatusIcon;
}(_UploadStatusBaseClass2.default), _class2.propTypes = {
  cancelable: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  containerClassName: _propTypes2.default.string,
  deletable: _propTypes2.default.bool,
  id: _propTypes2.default.number,
  onCancel: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  uploader: _propTypes2.default.object
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'cancel', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'cancel'), _class.prototype)), _class);
exports.default = UploadStatusIcon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FineUploader/UploadStatusIcon.js
// module id = 2004
// module chunks = 1